let routers = [
    {
        path: '/statistics/realtime',
        name: 'realtime',
        component: () => import('@/views/statistics/realtime.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    },
    {
        path: '/statistics/dashboard',
        name: 'dashboard',
        component: () => import('@/views/statistics/dashboard.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    },
    {
        path: '/statistics/SysVisit',
        name: 'SysVisit',
        component: () => import('@/views/statistics/SysVisit.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    }
    ,
    {
        path: '/statistics/reports/spu_traffic',
        name: 'spu_traffic',
        component: () => import('@/views/statistics/reports/spu_traffic.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    }
    ,
    {
        path: '/statistics/reports/region_traffic',
        name: 'region_traffic',
        component: () => import('@/views/statistics/reports/region_traffic.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    }
    ,
    {
        path: '/statistics/reports/page_statistic',
        name: 'page_statistic',
        component: () => import('@/views/statistics/reports/page_statistic.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    }
    ,
    {
        path: '/statistics/reports/blog_traffic',
        name: 'blog_traffic',
        component: () => import('@/views/statistics/reports/blog_traffic.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    },
    {
        path: '/statistics/seorep',
        name: 'seorep',
        component: () => import('@/views/statistics/seorep.vue'),
        meta: {keepAlive: true, parentPath: 'statistics'},
    }
    
]
export default routers


// WEBPACK FOOTER //
// ./src/router/statistics.js